import { render, staticRenderFns } from "./BDXNewBrokerForm.vue?vue&type=template&id=53e2fd7e"
import script from "./BDXNewBrokerForm.vue?vue&type=script&lang=js"
export * from "./BDXNewBrokerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports